export * from './CloseIcon';
export * from './HamburgerIcon';
export * from './ChevronIcon';
export * from './StarIcon';
export * from './RightArrowIcon';
export * from './LeftArrowIcon';
export * from './XIcon';
export * from './LinkedInIcon';
export * from './FacebookIcon';
export * from './LinkIcon';
export * from './CheckIcon';
export * from './DevsuWhiteIcon';
export { ArrowRightIcon } from './ArrowRightIcon';
export { UploadCloudLightIcon } from './UploadCloudLightIcon';
export { CubeDuotoneIcon } from './CubeDuotoneIcon';
export { UsersGroupLightIcon } from './UsersGroupLightIcon';
export { default as PlayIcon } from './PlayIcon';
export { default as YouTubeIcon } from './YouTubeIcon';
export { default as InstagramIcon } from './InstagramIcon';
//logos
export * from './logos/DevsuLogo';
